<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1" id="Mercurys_Rise.html" xml:lang="en-US">
<div class="calibre1">
<p class="book-title">Mercury’s Rise</p>
<p class="book-subtitle" xml:lang="en-GB">A Silver Rush Mystery</p>
<p class="book-author" xml:lang="en-GB">Ann Parker</p>
<p class="body-center"><a class="calibre2" href="http://www.annparker.com" target="_blank"><span class="hyperlink" xml:lang="en-US">www.AnnParker.com</span></a></p>
<p class="book-publisher" xml:lang="en-GB">Poisoned Pen Press</p>
<p class="body-center"><img alt="PPPlogo.jpg" class="image1" src="OEBPS/images/PPPlogo_fmt.png"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Mercurys_Rise.vue?4a597dac